/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { Injectable } from "@jkhy/frontend-utils/di";
import { TmHttpClient } from "@treasury/core/http";
import { createSwaggerClient } from "../../utils/tm-swagger-client";

import {
  BaseResponseStopPaymentServiceDto,
  GetEligibleStopPaymentAccountsRequestDto,
  GetEligibleStopPaymentAccountsResponseDto,
  SaveCompanyStopPaymentRequestDto,
} from "../";
import { ContentType, HttpClient, RequestParams } from "./http-client";

@Injectable()
export class StopPaymentClient {
  private readonly http: HttpClient;

  constructor(tmHttp: TmHttpClient) {
    this.http = createSwaggerClient(tmHttp, HttpClient);
  }

  /**
   * No description
   *
   * @tags StopPayment
   * @name StopPaymentGetEligibleStopPaymentAccountsGet
   * @summary Gets eligible stop payment accounts.
   * @request GET:/StopPayment/GetEligibleStopPaymentAccounts/{companyId}
   */
  stopPaymentGetEligibleStopPaymentAccountsGet = (
    companyId: number,
    params: RequestParams = {},
  ) =>
    this.http.request<BaseResponseStopPaymentServiceDto, any>({
      path: `/StopPayment/GetEligibleStopPaymentAccounts/${companyId}`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags StopPayment
   * @name StopPaymentGetEligibleStopPaymentAccountsPost
   * @summary Gets eligible stop payment accounts using GetEligibleStopPaymentAccountsRequest
   * @request POST:/StopPayment/GetEligibleStopPaymentAccounts
   */
  stopPaymentGetEligibleStopPaymentAccountsPost = (
    data: GetEligibleStopPaymentAccountsRequestDto,
    params: RequestParams = {},
  ) =>
    this.http.request<GetEligibleStopPaymentAccountsResponseDto, any>({
      path: `/StopPayment/GetEligibleStopPaymentAccounts`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags StopPayment
   * @name StopPaymentGetCompanyConfiguration
   * @summary Gets company configurations for stop payments.
   * @request GET:/StopPayment/GetCompanyConfiguration/{companyId}
   */
  stopPaymentGetCompanyConfiguration = (
    companyId: number,
    params: RequestParams = {},
  ) =>
    this.http.request<BaseResponseStopPaymentServiceDto, any>({
      path: `/StopPayment/GetCompanyConfiguration/${companyId}`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags StopPayment
   * @name StopPaymentSaveCompanyConfiguration
   * @summary Posts stop payment configuration for a given company.
   * @request POST:/StopPayment/SaveCompanyConfiguration
   */
  stopPaymentSaveCompanyConfiguration = (
    data: SaveCompanyStopPaymentRequestDto,
    params: RequestParams = {},
  ) =>
    this.http.request<BaseResponseStopPaymentServiceDto, any>({
      path: `/StopPayment/SaveCompanyConfiguration`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
}
